<template>
  <van-pull-refresh class="pulldown-page" :head-height="computeHeight" v-model="isLoading" @refresh="refreshHandler" ref="refresh" :class="!isScroll&&'height100'">
    <span slot="loading" class="loading" :style="{ color: color || '#FFFFFF' }">
      <i class="iconfont icon-sppiner"></i>
      加载中...
    </span>
    <div class="page" ref="page">
      <slot></slot>
    </div>
  </van-pull-refresh>
</template>
<script>
export default {
  name: 'pulldown-page',

  props: {
    refresh: {
      type: Function,
      default: () => new Promise(resolve => {
        setTimeout(() => {
          resolve(true)
        }, 100000)
      })
    },

    color: {
      type: String,
      default: ''
    },

    background: {
      type: String,
      default: ''
    },
    isScroll: Boolean
  },

  data () {
    return {
      isLoading: false,
      computeHeight: 100
    }
  },

  created () {
    this.computeHeight = document.documentElement.style.fontSize.replace('px', '') * 1.2
  },

  watch: {
    // 通知axios这时不要展示
    isLoading (value) {
      if (value) {
        this.$bus.$emit('loading')
      } else {
        this.$bus.$emit('ready')
      }
    }
  },

  mounted () {
    var dom = this.$refs['refresh'].$el
    if (this.color) {
      var header = dom.querySelector('.van-pull-refresh__head')
      header.style.color = this.color
    }
    if (this.background) {
      dom.style.backgroundColor = this.background
    }
  },

  methods: {
    async refreshHandler () {
      await this.refresh()
      this.isLoading = false
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.height100{
    height:100% !important;
}
    .pulldown-page {
        background-color: @theme;
        // height: 100%;
        // overflow: scroll;
        .loading {
            position: relative;
            display: inline-block;

            .iconfont {
                font-size: 26px;
                display: inline-block;
                animation: .8s rotate ease-in infinite;
            }
        }

        @keyframes rotate {
            from {
                transform: rotate(0deg)
            }

            to {
                transform: rotate(360deg)
            }
        }

        .van-pull-refresh__track {
            height: 100%;
            .van-pull-refresh__head {
                font-size: 26px;
                color: #FFFFFF;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                height: 90px;
                line-height: 90px;
                top: -90px;

                .van-loading__text {
                    color: #FFFFFF;
                }
                .van-loading__spinner {
                    color: #FFFFFF!important;
                }
            }
        }
    }
</style>